//React Components and Hooks
//Material UI Components
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import moment from "moment";
import React from "react";

const UploadsTable = (props) => {
  const rows = props.uploads;

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell>Date Uploaded</TableCell>
            <TableCell>Filename</TableCell>
            <TableCell>Lockbox Reading Count</TableCell>
            <TableCell>File</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell>
                  {moment(row.created).format("YYYY-MM-DD HH:MM:SS")}
                </TableCell>
                <TableCell>{row.fileName}</TableCell>
                <TableCell align="center">{row.readingCount}</TableCell>
                <TableCell>
                  <a target="_blank" href={`${row.url}`}>
                    <AttachFileIcon></AttachFileIcon>
                  </a>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UploadsTable;
